import { motion } from "framer-motion";
import { Helmet } from "react-helmet";
import ImageWithSkeleton from "../component/ImageWithSkeleton";

export default function Partners() {
  const statsData = [
    { value: "500+", label: "Crypto currencies Integrated" },
    { value: "20+", label: "Network supported" },
    { value: "150+", label: "Currency Listed in CMC & CG" },
    { value: "$100M", label: "Crypto currencies Integrated" },
  ];
  return (
    <>
      <Helmet>
        <title>Our Partners | Blockcryp Blockchain & AI Collaborations</title>
        <meta
          name="description"
          content="Meet Blockcryp’s trusted partners in blockchain, AI, and Web3. Explore our global collaborations that drive innovation in decentralized technologies."
        />
        <meta
          name="keywords"
          content=" Blockcryp partners, blockchain technology partners, AI development partnerships, Web3 collaborations, strategic tech partners, crypto project partners, NFT platform partnerships, DeFi ecosystem partners, metaverse development partners, blockchain alliance members"
        />
      </Helmet>
      {/* ------------ hero partner section start --------- */}
      <section className="token_hero space80">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <motion.h1
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="heading_h1 fw-bold mb-3  "
              >
                Decentralize With
                <span className="text-primary ms-3">Blockcrype</span>
              </motion.h1>
              <motion.p
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="pera_txt"
              >
                Nadcab Prioritize the Growth of the Partners Join Our Mission
                For a Decentralized World Backed by Expert Guidance.
              </motion.p>
              {/* <button class="button theme_btn mt-lg-4 mt-0" type="submit">
                Contact Us
              </button> */}
            </div>
            <div className="col-lg-6">
              <motion.div
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
              >
                <ImageWithSkeleton
                  src="assets/images/partner/partners.webp"
                  alt=""
                  className="w-100"
                />
                {/* <img
                  src="assets/images/partner/partners.webp"
                  alt="partner"
                  className="w-100"
                /> */}
              </motion.div>
            </div>
          </div>
        </div>
      </section>
      {/* ------------ hero partner section end --------- */}
      {/* -   Strategic Collaboration start ---  */}
      <section className="Strategic space80">
        <div className="container">
          <div className="row justify-content-center mb-4 mb-lg-5">
            <div className="col-12">
              <motion.h2
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className=" heading_h3 fw-bold mb-3 text-center text-capitalize"
              >
                Our Partnership Programs For <br></br>
                <span className="text-primary ps-2">
                  Strategic Collaboration
                </span>
              </motion.h2>
            </div>
          </div>

          <div className="row justify-content-center">
            <div className="col-lg-6 col-md-6 mb-4">
              <motion.div
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="strategic_card"
              >
                <h5 className="fw-semibold mb-3">
                  Strategic Alliance Partnership
                </h5>
                <p className="mb-0">
                  Collaborate with Blockcryp on multi-vertical initiatives
                  including blockchain, AI, and smart contract deployments.
                  Drive long-term innovation, market expansion, and mutual
                  client success with shared vision and execution.
                </p>
              </motion.div>
            </div>
            <div className="col-lg-6 col-md-6 mb-4">
              <motion.div
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="strategic_card"
              >
                <h5 className="fw-semibold mb-3">
                  Incubation Support Partnership
                </h5>
                <p className="mb-0">
                  Inspire new startups and businesses with our blockchain
                  infrastructure, mentorship, and dev resources. Ideal for
                  accelerators, VCs, and incubators aiming to launch scalable,
                  Web3-native ventures quickly and securely.
                </p>
              </motion.div>
            </div>
            <div className="col-lg-6 col-md-6 mb-4">
              <motion.div
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="strategic_card"
              >
                <h5 className="fw-semibold mb-3">SaaS Reseller Partnership</h5>
                <p className="mb-0">
                  Resell SaaS-based blockchain tools, applications, and
                  platforms built by Nadcab to enterprises and developers. Get
                  white-label options, technical support, and exclusive pricing
                  to scale recurring revenue streams effectively.
                </p>
              </motion.div>
            </div>
            <div className="col-lg-6 col-md-6 mb-4">
              <motion.div
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="strategic_card"
              >
                <h5 className="fw-semibold mb-3">
                  Education & Training Partnership
                </h5>
                <p className="mb-0">
                  Partner with Nadcab to offer certified blockchain development
                  training, workshops, and hands-on developer programs.
                  Co-create learning pathways for educational institutions,
                  enterprises, and technology upskillers globally.
                </p>
              </motion.div>
            </div>
          </div>
        </div>
      </section>
      {/* -   Strategic Collaboration end ---  */}

      {/* ---------  Specialties start ----------- */}
      <section className="specialties space80">
        <div className="container">
          <div className="row justify-content-center mb-4 mb-lg-5">
            <div className="col-12">
              <motion.h2
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="heading_h3 fw-bold mb-3 text-center text-capitalize"
              >
                Our
                <span className="text-primary ps-2">Specialties</span>
              </motion.h2>
              <motion.p
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="text-center pera_txt"
              >
                We are equipped with the experience, expertise, and resources to
                deliver end-to-end <br></br> solutions to boost the growth of
                our partners and customers.
              </motion.p>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-lg-11">
              <div className="specialties_card border_lg">
                <div className="row justify-content-around align-items-center flex-wrap">
                  <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    viewport={{ once: false, amount: 0.5 }}
                    className="col-lg-4 col-md-6 mb-4"
                  >
                    <div className="card-icon">
                      <i class="fa-solid fa-users"></i>
                    </div>
                    <p class="text_20 mb-0 text-center">
                      A growing team with <br></br> 500+ employees
                    </p>
                  </motion.div>
                  <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    viewport={{ once: false, amount: 0.5 }}
                    className="col-lg-4 col-md-6 mb-4"
                  >
                    <div className="card-icon">
                      <i class="fas fa-tools"></i>
                    </div>
                    <p class="text_20 mb-0 text-center">
                      Matchless technical skills <br></br>and expertise
                    </p>
                  </motion.div>
                  <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1, delay: 0.5 }}
                    viewport={{ once: false, amount: 0.5 }}
                    className="col-lg-4 col-md-6 mb-4"
                  >
                    <div className="card-icon">
                      <i class="fas fa-cubes"></i>
                    </div>
                    <p class="text_20 mb-0 text-center">
                      Blockcryp is a ‘Global Industry <br></br> Leader’ in the
                      blockchain niche.
                    </p>
                  </motion.div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ---------  Specialties end ----------- */}
      {/* -----------  why us join network sec start ------------- */}
      <section className="why-join cta space80">
        <div className="container">
          <div className="row justify-content-center mb-4 mb-lg-3">
            <div className="col-12">
              <motion.h2
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="heading_h3 fw-bold mb-3 text-center text-capitalize"
              >
                Why Join Our
                <span className="text-primary ps-2"> Growth Network?</span>
              </motion.h2>
            </div>
          </div>
          <div className="row">
            {statsData.map((item, index) => (
              <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12" key={index}>
                <motion.div
                  initial={{ opacity: 0, x: -50 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 1, delay: 0.3 * index }}
                  viewport={{ once: false, amount: 0.5 }}
                  className="blockcryp_number"
                >
                  <div className="x">
                    <span className="heading_h2 fw-bold text-primary">
                      {item.value}
                    </span>
                  </div>
                  <div className="pera_txt">{item.label}</div>
                </motion.div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* -----------  why us join network sec end ------------- */}
      {/* ----------- partner section start ---------------- */}
      {/* <section className="partner-form space80">
        <div className="container">
          <div className="row justify-content-center mb-4 mb-lg-5">
            <div className="col-12">
              <motion.h2
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="heading_h3 fw-bold mb-3 text-center text-capitalize"
              >
                Interested in becoming{" "}
                <span className="text-primary ps-2"> our partner?</span>
              </motion.h2>
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-12">
              <motion.div
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.5 }}
                viewport={{ once: false, amount: 0.5 }}
                className="part_form border_lg"
              >
                <div className="row">
                  <div className="col-md-6 col-sm-6">
                    <div className="mb-3">
                      <label>Comapny Name</label>
                      <span className="text-danger ms-1">*</span>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Comapny Name"
                        name="company name"
                        id="company name"
                        required=""
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-6">
                    <div className="mb-3">
                      <label>Comapny URL</label>
                      <span className="text-danger ms-1">*</span>
                      <input
                        type="url"
                        className="form-control"
                        placeholder="Comapny URL"
                        name="url"
                        id="url"
                        required=""
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-6">
                    <div className="mb-3">
                      <label>Your Name</label>
                      <span className="text-danger ms-1">*</span>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Your Name"
                        name="name"
                        id="name"
                        required=""
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-6">
                    <div className="mb-3">
                      <label>Email</label>
                      <span lassName="text-danger ms-1">*</span>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Enter Your Email"
                        name="email"
                        id="email"
                        required=""
                      />
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-6">
                    <div className="mb-3">
                      <label>Phone </label>
                      <span className="text-danger ms-1">*</span>
                      <div className="input_group">
                        <input
                          type="tel"
                          className="form-control"
                          placeholder="Phone Number"
                          name="contact"
                          id="phone"
                          pattern="[0-9]{10}"
                          required=""
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-6">
                    <div className="mb-3">
                      <label>Designation</label>
                      <span className="text-danger ms-1">*</span>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="designation"
                        name="designation"
                        id="designation"
                        required=""
                      />
                    </div>
                  </div>
                  <div className="col-md-12 col-sm-12">
                    <div className="mb-3">
                      <label>Message</label>
                      <span className="text-danger ms-1">*</span>
                      <textarea
                        type="email"
                        rows="6"
                        className="form-control"
                        placeholder="Message"
                        name="Message"
                        id="Message"
                        required=""
                      />
                    </div>
                  </div>

                  <div className="col-12 mt-3">
                    <button
                      class="button theme_btn mt-4 mt-lg-0"
                      type="submit"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>
        </div>
      </section> */}
      {/* ----------- partner section end ---------------- */}
    </>
  );
}
